import { render, staticRenderFns } from "./upload-element.vue?vue&type=template&id=0313fd82&scoped=true"
import script from "./upload-element.vue?vue&type=script&lang=js"
export * from "./upload-element.vue?vue&type=script&lang=js"
import style0 from "./upload-element.vue?vue&type=style&index=0&id=0313fd82&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"
import style1 from "./upload-element.vue?vue&type=style&index=1&id=0313fd82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0313fd82",
  null
  
)

export default component.exports